<template>
  <div>
    <template v-if="differentDatesOnBookings">
      <v-text-field
        :label="$t('fields.checkin')"
        :value="checkin"
        append-icon="mdi-calendar"
        outlined
        readonly
      ></v-text-field>
      <v-text-field
        :label="$t('fields.checkout')"
        :value="checkout"
        append-icon="mdi-calendar"
        outlined
        readonly
      ></v-text-field>
    </template>
    <div v-for="(room, indexRoom) in roomsByBooking.rooms" :key="'room-' + indexRoom" class="booking-room">
      <div class="booking-room-name">
        {{ $t('headers.room') }} {{ room.name }}
      </div>
      <v-btn
        v-for="(guest, indexGuest) in room.guests"
        :key="'room-' + indexRoom + '-guest-' + indexGuest"
        @click="goToGuest(guest.guest.id)"
        block
        outlined
        class="v-btn-booking-guest mb-4"
      >
        {{guest.profile.name}} {{guest.profile.lastName || null}}
      </v-btn>
    </div>
    <div v-if="roomsByBooking.guestsWithoutRoom.length > 0" class="booking-room">
      <div class="booking-room-name">
        {{ $t('headers.without_room')}}
      </div>
      <v-btn
        v-for="(guest, indexGuest) in roomsByBooking.guestsWithoutRoom"
        :key="'guest-' + indexGuest"
        @click="goToGuest(guest.guest.id)"
        block
        outlined
        class="v-btn-booking-guest mb-4"
      >
        {{guest.profile.name}} {{guest.profile.lastName || null}}
      </v-btn>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { displayFormatDateAndHour } from '@/lib/helpers/DateUtils'

export default {
  props: {
    roomsByBooking: Object,
    differentDatesOnBookings: Boolean,
  },
  computed: {
    checkin () {
      return this.roomsByBooking.booking.checkin ? displayFormatDateAndHour(moment(this.roomsByBooking.booking.checkin).local(), true) : ''
    },
    checkout () {
      return this.roomsByBooking.booking.checkout ? displayFormatDateAndHour(moment(this.roomsByBooking.booking.checkout).local(), true) : ''
    },
  },
  methods: {
    goToGuest (id) {
      this.$router.push({ path: `booking/${ this.roomsByBooking.booking.id }/guest/${ id }` })
      window.scrollTo(0, 0)
    },
  },
}
</script>
